export default "__VITE_ASSET__Dy19T4gA__"